import {ActionTree} from "vuex";
import {DataPropertyProfileState, DataPropertyProfile} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<DataPropertyProfileState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/data_property_profiles', {params: params})
        .then((response: AxiosResponse) => {
          const dataPropertyProfiles: DataPropertyProfile[] = response.data;
          commit('setDataPropertyProfiles', dataPropertyProfiles);
          return dataPropertyProfiles;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/data_property_profiles', params)
        .then((response: AxiosResponse) => {
          const dataPropertyProfile: DataPropertyProfile = response.data;
          commit('addDataPropertyProfile', dataPropertyProfile);
          return dataPropertyProfile;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/data_property_profiles/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const dataPropertyProfile: DataPropertyProfile = response.data;
          commit('updateDataPropertyProfile', dataPropertyProfile);
          return dataPropertyProfile;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/data_property_profiles/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteDataPropertyProfile', id);
        });
  }
}

export default actions;
